module.exports = __webpack_public_path__ + "static/media/ae.7847726d.svg";